import { Component, Prop } from 'vue-property-decorator';
import GeneracionesRegistro from '@/entities/snp/solicitud/posgrado/generaciones/generaciones-registro.vue';
import GeneracionesListado from '@/entities/snp/solicitud/posgrado/generaciones/generaciones-listado.vue';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { GeneracionSnp } from '@/shared/model/snp/generaciones.model';

@Component({
  components: {
    'generaciones-registro': GeneracionesRegistro,
    'generaciones-listado': GeneracionesListado,
  },
})
export default class GeneracionesSnpComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  public toggleActualizarTabla = false;
  public mostrarRegistro = false;
  public mostrarListado = true;

  public actualizar(generaciones: Array<GeneracionSnp>): void {
    this.toggleActualizarTabla = !this.toggleActualizarTabla;
    this.mostrarRegistro = false;
    this.mostrarListado = true;
    this.$emit('submit', { generaciones: generaciones });
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
